import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { COURIER_TEMPLATES_BASE_URL } from './helpers';
import { ICourierNotificationTemplateVariablesResponse } from './types';

export const useCourierTemplateVariables = (templateId?: string) => {
  const url = templateId
    ? `${COURIER_TEMPLATES_BASE_URL}/${templateId}/variables`
    : null;

  const { data, error, isLoading, mutate } =
    useSWR<ICourierNotificationTemplateVariablesResponse>(url, SWRFetcher({ method: 'GET' }));

  return { data, error, isLoading, mutate };
};
